import React from 'react';
import SkeletonLoader from './SkeletonLoader';

const TimedMessagesSkeleton: React.FC = () => {
  return (
    <section id="timed-messages" className="content-section">
      <div className="flex justify-between items-center mb-6 header-border pb-4">
        <h2 className="text-xl font-semibold text-white">timed messages</h2>
        <SkeletonLoader width="w-32" height="h-10" className="rounded" />
      </div>
      
      <div className="space-y-4">
        {[1, 2, 3].map((i) => (
          <div key={i} className="paint-card p-4">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <SkeletonLoader width="w-4" height="h-4" className="rounded" />
                  <SkeletonLoader width="w-48" height="h-5" />
                </div>
                <div className="mb-2">
                  <SkeletonLoader width="w-full" height="h-4" className="mb-1" />
                  <SkeletonLoader width="w-3/4" height="h-4" />
                </div>
                <div className="flex items-center gap-4">
                  <SkeletonLoader width="w-20" height="h-3" />
                  <SkeletonLoader width="w-24" height="h-3" />
                  <SkeletonLoader width="w-32" height="h-3" />
                </div>
              </div>
              <div className="flex items-center gap-2 ml-4">
                <SkeletonLoader width="w-6" height="h-6" className="rounded" />
                <SkeletonLoader width="w-6" height="h-6" className="rounded" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TimedMessagesSkeleton;